<template>
  <div class="checklist-container">
    <h1>Stationen Checkliste</h1>
    <ul class="checklist">
      <li
        v-for="station in stations"
        :key="station.id"
        :class="{ completed: station.completed }"
      >
        <span>{{ station.name }}</span>
        <span v-if="station.completed" class="status">✅</span>
      </li>
    </ul>
    <button @click="finishTour" v-if="allStationsCompleted">
      Goodies abholen
    </button>
    <button @click="resetChecklist" class="reset-btn">
      Checkliste zurücksetzen
    </button>
  </div>
</template>

<script>
export default {
  name: "StationChecklist",
  data() {
    return {
      stations: [], // Liste der Stationen
    };
  },
  computed: {
    allStationsCompleted() {
      return this.stations.every((station) => station.completed);
    },
  },
  created() {
    this.loadStations();
  },
  methods: {
    loadStations() {
      try {
        // Lade Stationen aus dem localStorage
        const savedStations = JSON.parse(localStorage.getItem('stations')) || [];
        if (savedStations.length === 0) {
          this.stations = [
            { id: 1, name: 'BW/UNCO/OMAI/WINF', completed: false },
            { id: 2, name: 'International Business', completed: false },
            { id: 3, name: 'digBiz-HAK', completed: false },
            { id: 4, name: 'Marketing & Sales', completed: false },
            { id: 5, name: 'Betriebswirtschaftliches Zentrum', completed: false },
            { id: 6, name: 'Handelsschule', completed: false },
            { id: 7, name: 'Erasmus+', completed: false },
            { id: 8, name: 'Bewegung und Sport', completed: false },
            { id: 9, name: 'Lebende Fremdsprachen', completed: false },
            { id: 10, name: 'Naturwissenschaften', completed: false },
            { id: 11, name: 'Bibliothek', completed: false },
            { id: 12, name: 'Abend HAK', completed: false },
          ];
        } else {
          this.stations = savedStations;
        }
        this.saveStations(); // Speichere direkt nach dem Laden
      } catch (error) {
        console.error('Fehler beim Laden der Stationen:', error);
        this.stations = []; // Fallback auf leere Liste
      }
    },
    saveStations() {
      try {
        localStorage.setItem('stations', JSON.stringify(this.stations));
      } catch (error) {
        console.error('Fehler beim Speichern der Stationen:', error);
      }
    },
    finishTour() {
      alert('Herzlichen Glückwunsch! Du kannst jetzt deine Goodies abholen.');
    },
    resetChecklist() {
      this.stations.forEach((station) => (station.completed = false));
      this.saveStations();
    },
  },
};
</script>

<style scoped>
.checklist-container {
  text-align: center;
  padding: 20px;
}
.checklist {
  list-style: none;
  padding: 0;
}
.checklist li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin: 5px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.completed {
  background-color: #d4edda;
}
button {
  background-color: #ff6600;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
button:hover {
  background-color: #e65c00;
}
.status {
  font-weight: bold;
}
.reset-btn {
  margin-top: 20px;
  background-color: #d9534f;
}
.reset-btn:hover {
  background-color: #c9302c;
}
</style>
